/// <amd-module name="Analytics/Shared/Visuals/Common/Components/VisualTemplate" />
import { ILabelledContextualMenuProps, LabelledContextualMenu } from "Analytics/Shared/Visuals/Common/Components/LabelledContextualMenu";
import * as React from "react";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";

export interface IVisualTemplateProps extends IVssComponentProperties {
    title?: string;
    titleClassName?: string;
    titleId?: string;

    subTitle?: string;
    labelledMenuProps?: ILabelledContextualMenuProps;

    tabIndex?: number;
    arialabelledby?: string;
}

/** VisualTemplate provides the basic template required for the Visual.
 * We can add the title or provide the Menu Options to be displayed in the Visual.
 * Menu options properties should be provided in the labelledMenuProps.
 */
export class VisualTemplate extends VssComponent<IVisualTemplateProps> {
    public render(): JSX.Element {
        return (
            <div
                className={css("visual-template", this.props.className)}
                tabIndex={this.props.tabIndex}
                aria-labelledby={this.props.arialabelledby}
                style={this.props.style}
            >
                {this._getTitleBar()}

                {this.props.subTitle && <div className="sub-title fontSizeM fontWeightLighter">{this.props.subTitle}</div>}

                {this.props.children}
            </div>
        );
    }

    private _getTitleBar() {
        if (this.props.labelledMenuProps) {
            const labelledMenuProps = this.props.labelledMenuProps;
            return (
                <Tooltip text={labelledMenuProps.tooltipHostContent || ""}>
                    {labelledMenuProps.metricOptions &&
                        typeof labelledMenuProps.selectedMetricOption === "number" &&
                        labelledMenuProps.metricOptions[labelledMenuProps.selectedMetricOption] && (
                            <LabelledContextualMenu {...this.props.labelledMenuProps} />
                        )}
                </Tooltip>
            );
        }
        return (
            <h2 className={css("title fontWeightNormal", this.props.titleClassName)} id={this.props.titleId}>
                {this.props.title}
            </h2>
        );
    }
}
